/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validMobilePhone(str) {
  const reg = /^[1](([3][0-9])|([4][0-9])|([5][0-9])|([6][0-9])|([7][0-9])|([8][0-9])|([9][0-9]))[0-9]{8}$/;

  return reg.test(str);
}

/**
 * @description 校验身份证号
 * @return false: 校验失败 Object: 出生日期和性别
 */
export function idNoTest(idNo) {
  let t, year, mon, day, areaTest, genderNum, genderDscp, genderCd;
  // 第一步，正则校验
  if (!new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/).test(idNo)) {
    return false;
  }
  // 第二步：拆分年月日，进行时间校验
  t = idNo.slice(6, 14);
  year = t.slice(0, 4);
  mon = parseInt(t.slice(4, 6));
  day = parseInt(t.slice(6, 8));
  if(!dateTest(year, mon, day)){
    return false;
  }
  // 第三步：判断最后一位数字的正确性
  if(!idNoLastNumTest(idNo)){
    return false;
  }
  // 第四步：判断前六位数字是否正确
  areaTest = idNoAreaTest(idNo);
  if(!areaTest) {
    return false;
  }
  // 都通过了，则返回对象，以此校验出生日期和性别
  genderNum = idNo.slice(-2, -1);
  if(genderNum%2==0){
    genderDscp = '女';
    genderCd=0;
  }else{
    genderDscp = '男';
    genderCd=1;
  }
  mon<10&&(mon = '0'+mon);
  day<10&&(day = '0'+day);
  //计算年龄
  let data = new Date
  let age = data.getFullYear()-year
  return {
    birthDay: `${year}-${mon}-${day}`,
    genderCd: genderCd,
    genderDscp: genderDscp,
    makerAge:age
  };
}

/**
 * @description 校验身份证号-校验出生日期是否正确
 */
function dateTest(year, mon, day) {
  if(!day||!mon){
    return false;
  }
  if(new Date(`${year}-${mon}-${day}`).getTime()>new Date().getTime()){
    return !1;
  }
  if(year%4==0&&(year%100!=0||year%400==0)){
    if(mon==2){
      if(day<=29){
        return true;
      }else{
        return !1;
      }
    }
  }else{
    if(mon==2){
      if(day<=28){
        return true;
      }else{
        return false;
      }
    }
  }
  if(mon==1 || mon==3 || mon==5 || mon==7 || mon==8 || mon==10 || mon==12){
    if(day<=31){
      return true;
    }else{
      return false;
    }
  }else if(mon==4 || mon==6 || mon==9 || mon==11){
    if(day<=30){
      return true;
    }else{
      return false;
    }
  }else if(mon!=2){
    return false;
  }
}

/**
 * @description 校验身份证号-校验最后一位数字是否正确
 */
function idNoLastNumTest(idNo) {
  let num, lastNum;
  num = idNo[0]*7;
  num+= idNo[1]*9;
  num+= idNo[2]*10;
  num+= idNo[3]*5;
  num+= idNo[4]*8;
  num+= idNo[5]*4;
  num+= idNo[6]*2;
  num+= idNo[7]*1;
  num+= idNo[8]*6;
  num+= idNo[9]*3;
  num+= idNo[10]*7;
  num+= idNo[11]*9;
  num+= idNo[12]*10;
  num+= idNo[13]*5;
  num+= idNo[14]*8;
  num+= idNo[15]*4;
  num+= idNo[16]*2;
  lastNum = idNo[17]+'';
  switch (num%11){
    case 0:
      if(lastNum !== '1'){
        return false;
      }
      break;
    case 1:
      if(lastNum !== '0'){
        return false;
      }
      break;
    case 2:
      if(lastNum !== 'X' && lastNum !== 'x') {
        return false;
      }
      break;
    case 3:
      if(lastNum !=='9') {
        return false;
      }
    break;
    case 4:
      if(lastNum !== '8') {
        return false;
      }
    break;
    case 5:
      if(lastNum !== '7') {
        return false;
      }
      break;
    case 6:
      if(lastNum !== '6') {
        return false;
      }
      break;
    case 7:
      if(lastNum !== '5') {
        return false;
      }
      break;
    case 8:
      if(lastNum !== '4') {
        return false;
      }
      break;
    case 9:
      if(lastNum !== '3'){
        return false;
      }
      break;

    case 10:
      if(lastNum !== '2'){
        return false;
      }
      break;
  }
  return true;
}

/**
 * @description 校验身份证号-校验前6位数字是否正确
 */
function idNoAreaTest(idNo) {
  let i, stateNum, s, stateTest, idArea = idNo.slice(0, 6);
  const cityList = ['110000','120000','130000','140000','150000','210000','220000',
                    '230000','310000','320000','330000','340000','350000','360000',
                    '370000','410000','420000','430000','440000','450000','460000',
                    '500000','510000','520000','530000','540000','610000','620000',
                    '630000','640000','650000','710000','810000','820000','910000'];
  stateNum = idArea.slice(0, 2);
  for (i = 0; i < cityList.length; i++) {
    s = cityList[i].slice(0, 2);
    if(stateNum === s){
      stateTest = cityList[i];
      break;
    }
  }
  if(!stateTest){
    return false;
  }
  return true;
}